import React from "react";

import Select from "../index";

export default function Job(props) {
  const items = ["queued", "executing", "finished", "retrying", "failed"];

  return <Select label="Status" items={items} {...props} />;
}
